<template>
  <div>
    <div
      v-for="(v,i) in sonDatas"
      :key="i"
      class="item"
    >
      <div class="c-p-20">
        <div class="c-fl-bt top-line-box">
          <div>在线购买</div>
          <div
            class="c-fl-bt delete-box"
            @click="deleteList"
          >
            <div>{{v.Status.Name}}</div>
            <g-img
              :src="require('@/assets/images/clearCar.png')"
              :size="40"
              color="#888"
            ></g-img>
          </div>
        </div>
        <div
          class="c-fl content"
          @click="toOrderDetail(v.Id, v.Status.Id)"
        >
          <div class="l">
            <img
              :src="v.Details[0].ProductImageUrl"
              alt=""
              srcset=""
              class="l-img"
            >
          </div>

          <div class="r">
            <div class="r-box">
              <div class="c-fl-bt r-top">
                <div>{{v.Details[0].ProductName}}</div>
                <div><span>￥</span><span>{{v.Details[0].SettlePrice}}</span></div>
              </div>
              <div class="x-num">x{{v.Details[0].Quantity}}</div>

              <div>
                <div class="order-num"> 订单编号: {{v.Details[0].OrderId}}</div>
                <div>下单时间: {{v.CreateTime}}</div>
              </div>
            </div>
          </div>
        </div>
        <div>
          <div class="goods-box">
            <div>合计:<i class="c-yang">￥</i> <span class="money">{{v.Details[0].SettlePrice * v.Details[0].Quantity}}</span></div>
            <div class="total-box">共<b>{{v.Details[0].Quantity}}</b>件商品</div>
          </div>
        </div>
      </div>
      <g-line></g-line>
    </div>

  </div>
</template>

<script>
export default {
  name: "G-img-list",
  props: {
    faImg: {
      type: String,
      default: ''
    },
    datas: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      sonDatas: this.datas,
    };
  },
  watch: {
    datas(val) {
      this.sonDatas = val;
    }
  },
  created() {

  },
  mounted() {

  },
  methods: {
    toOrderDetail(item) {
      console.log('88888<<<  item  >>>88888');
      console.log(item);
      if (orderStatusCode !== 2 && orderStatusCode !== 0) { // 除了已取消和待支付的订单其他状态订单才可以查看消费码
        this.$router.push({
          name: 'ConsumeCode',
          params: { id: orderId }
        })
      }
      // this.$router.push({
      //   path: '/goods/orderDetail',
      //   query: { id: item.Id },
      // })
    },
    deleteList() {
      this.$parent.init();
      console.log('22222<<<  "删除"  >>>22222');
      console.log("删除");
      this.$dialog.confirm({
        title: '删除',
        message: '确定要删除当前列表吗',
      })
        .then(() => {
          // on confirm
          console.log('11111<<<  this.$parent  >>>11111');
          console.log(this.$parent);
          this.$emit('delete');
        })
        .catch(() => {
          // on cancel
        });
    }
  }
};
</script>
<style scoped lang='scss'>
.content {
  /* height: 200px; */
  .f {
    flex: 1;
  }
  .l-img {
    width: 130px;
    height: 130px;
    border-radius: 10px;
  }
  .r {
    flex: 2;
    margin-left: 20px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    height: 200px;
    width: 100%;
  }
  .r-top {
    .main-title {
      font-size: 30px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: #333333;
    }
    .sub-title {
      font-size: 22px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      margin-top: 20px;
    }
  }
  .r-bottom {
    .change-color {
      font-size: 28px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: var(--tc);
      margin-right: 10px;
    }
    .origin-color {
      font-size: 20px;
      font-family: PingFangHK-Regular, PingFangHK;
      font-weight: 400;
      color: #000000;
      text-decoration: line-through;
    }
  }
}
.top-line-box {
  font-size: 28px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #333333;
  margin-bottom: 20px;
  align-items: flex-end;
  .delete-box {
    width: 120px;
    font-size: 28px;
    align-items: center;
    font-size: 24px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #888888;
  }
}

.r-box {
  margin: 10px 10px 10px 0;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  width: 100%;
  font-size: 20px;
  font-family: PingFangHK-Regular, PingFangHK;
  font-weight: 400;
  color: #888888;
  height: 200px;
  box-sizing: border-box;
  .x-num {
    position: relative;
    top: -20px;
    text-align: right;
  }
  .r-top {
    font-size: 30px;
    font-family: PingFangHK-Regular, PingFangHK;
    font-weight: 400;
    color: #333333;
  }
  .order-num {
    margin-bottom: 10px;
  }
}
.goods-box {
  display: flex;
  flex-direction: row-reverse;
  align-items: baseline;
  margin-top: 20px;
  height: 44px;
  line-height: 44px;
  font-size: 24px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #333333;
  box-sizing: border-box;
  b {
    font-weight: unset;
  }
  i {
    font-style: unset;
    padding-left: 10px;
  }
  .total-box {
    padding-right: 10px;
  }
  .money {
    font-size: 32px;
  }
}
</style>
